import {Payment, PaymentActionTypes, UPDATE_PAYMENTS} from "./types";

export function updatePayments(payments: Array<Payment>): PaymentActionTypes {
  return {
    type: UPDATE_PAYMENTS,
    payload: payments
  }
}
